module.exports = __webpack_public_path__ + "static/img/FR.4379c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bouns/FR.png
// module id = 35gD
// module chunks = 1